import { defineMessages } from 'react-intl-next';

export const nonContextualNoteMessages = defineMessages({
	CJNNonContextualNote: {
		id: 'cross-join-nudges.contextual-note.generic',
		defaultMessage: '{requestingUser} needs {requestingApp} access {valueProp}.',
		description: 'Non-contextual note sent to admins when a user requests access via CJN',
	},
	jpdValueProp: {
		id: 'cross-join-nudges.non-contextual-note.jpd-value-prop',
		defaultMessage: 'to prioritize ideas and create roadmaps',
		description: 'Value prop for Jira Product Discovery',
	},
	jiraValueProp: {
		id: 'cross-join-nudges.non-contextual-note.jira-value-prop',
		defaultMessage: 'to plan and track work',
		description: 'Value prop for Jira',
	},
	loomValueProp: {
		id: 'cross-join-nudges.non-contextual-note.loom-value-prop',
		defaultMessage: 'to create and edit videos',
		description: 'Value prop for Loom',
	},
	confluenceValueProp: {
		id: 'cross-join-nudges.non-contextual-note.confluence-value-prop',
		defaultMessage: 'to collaborate on pages and whiteboards',
		description: 'Value prop for Confluence',
	},
});